import api from "./api";

export interface LocationDTO {
  id: number;
  city: string;
  country: string;
  displayName: string;
  isActive: boolean;
}

export const locationService = {
  // Get all active locations (for public display)
  getActiveLocations: async (): Promise<LocationDTO[]> => {
    const response = await api.get("/locations/active");
    return response.data;
  },

  // Get location by ID
  getLocationById: async (id: number): Promise<LocationDTO> => {
    const response = await api.get(`/locations/${id}`);
    return response.data;
  },

  // Get locations by country
  getLocationsByCountry: async (country: string): Promise<LocationDTO[]> => {
    const response = await api.get(`/locations/country/${country}`);
    return response.data;
  },
};

export default locationService;
